import { DocumentMetadataModel } from '@/apiTypes/SkillInferenceTypes';

export interface QuerySkillParams {
    page: number;
    limit: number;
    attributes?: string[];
    filters: {
        name?: string;
        type?: SkillEnum;
        occupationId?: string;
        skillTypes?: SkillEnum[];
        categoryIds?: string[];
        occupationIds?: string[];
    };
}

export enum SkillEnum {
    COMMON = 1,
    SPECIALIZED = 2,
    CERTIFICATION = 3,
}

export const SkillEnumDisplaySingle = {
    [SkillEnum.COMMON]: 'Durable skill',
    [SkillEnum.SPECIALIZED]: 'Learned skill',
    [SkillEnum.CERTIFICATION]: 'Certification',
};

export const SkillEnumDisplayPlural = {
    [SkillEnum.COMMON]: 'Durable skills',
    [SkillEnum.SPECIALIZED]: 'Learned skills',
    [SkillEnum.CERTIFICATION]: 'Certifications',
};

export enum SkillLevelEnum {
    NO_EXPERIENCE = 0,
    BEGINNER = 1,
    INTERMEDIATE = 2,
    ADVANCED = 3,
    EXPERT = 4,
}

export enum SkillStatusEnum {
    IN_PROGRESS = 1,
    COMPLETED = 2,
}

export const SkillLevelEnumDisplay = {
    [SkillLevelEnum.NO_EXPERIENCE]: 'No Experience',
    [SkillLevelEnum.BEGINNER]: 'Beginner',
    [SkillLevelEnum.INTERMEDIATE]: 'Intermediate',
    [SkillLevelEnum.ADVANCED]: 'Advanced',
    [SkillLevelEnum.EXPERT]: 'Expert',
};

export interface SkillSubCategoryModel {
    name: string;
    skillCategoryId: string;
}

export interface SkillModel {
    id: string;
    name: string;
    description: string | undefined;
    type: SkillEnum;
    skillSubCategoryId: string;
    externalSourceId: string;
    externalSourceValue: string;
    createdAt: string;
    updatedAt: string;
    skillSubCategory?: SkillSubCategoryModel;
}

export interface SkillCategoryModel {
    id: string;
    name: string;
    description: string | undefined;
    externalSourceId: string;
    externalSourceValue: string;
    createdAt: string;
    updatedAt: string;
}

// Cross Type for UserSkillModel and UserCustomSkillModel
export interface GenericSkillModel {
    userId: string;
    id: string;
    skillName: string;
    createdAt: string;
    updatedAt: string;
    skillLevel: SkillLevelEnum;
    skillId?: string;
    achievedDate?: string | null;
    goalDate?: string | null;
    note?: string | null;
    skillType?: SkillEnum;
    skillStatus?: SkillStatusEnum;
    skill?: SkillModel;
    description?: string | null;
    reason?: string | null;
    documentMetadata?: DocumentMetadataModel;
}
